export function getSeeMoreText(
    totalItemCount: number,
    maxVisibleItems: number,
    pluralNoun: string
): string {
    const actualVisibleItems =
        totalItemCount === maxVisibleItems + 1 ? maxVisibleItems - 1 : maxVisibleItems;

    const hiddenCount = totalItemCount - actualVisibleItems;

    return `See +${hiddenCount} ${pluralNoun}`;
}
